module.exports = __webpack_public_path__ + "static/media/proxima-nova-bold.8f84e893.woff2";